<template>
  <div class="explain-wrapper">
    <div class="title">
      {{ $t(star) }}入{{ $t(palaceName)
      }}<span v-if="palaceId != 0">{{ $t('gong') }}</span>
    </div>
    <button class="back" @click="back()">{{ $t('explain.back') }}</button>
    <div class="content">{{ $t(explainStr) }}</div>
  </div>
</template>
<script>
import { PanUtil } from '@/util'
export default {
  props: {
    palace: {
      type: String,
    },
    star: { type: String },
    palaceId: { type: String },
  },
  computed: {
    palaceName: function () {
      return PanUtil.PALACE_NAME[this.palaceId]
    },
    explainStr: function () {
      return `explain.${this.star}.${this.palaceName}`
    },
  },
  methods: {
    back: function () {
      if (typeof this.palace == 'undefined') {
        this.$router.push({
          name: 'Home',
        })
      } else {
        this.$router.push({
          name: 'ExplainList',
          params: { palace: this.palace },
        })
      }
    },
  },
}
</script>
<style scoped>
.explain-wrapper {
  padding: 30px 0;
}
.title {
  font-size: 30px;
  padding: 0px 0px 30px;
  font-weight: bolder;
}
.back {
  font-size: 20px;
}
.content {
  font-size: 18px;
  padding: 15px;
  line-height: 1.5;
  text-align: justify;
  white-space: pre-line;
}
</style>
